import {
    GET_RESE_LEAK_MONITORING_TABLE_DATA,
    GET_RESE_LEAK_MONITORING_MATERIAL_TYPE,
    GET_RESE_LEAK_MONITORING_MATERIAL_DURATION,
    POST_RESE_LEAK_MONITORING_INFORMATION,
    RESET_RESE_LEAK_MONITORING_SUBMIT_STATUS,
} from "./actionTypes";

const initialState = {
    reseLeakMonitoringTableData: [],
    totalRecords: 0,
    reseLeakMonitoringMaterialTypeData: [],
    reseLeakMonitoringMaterialDurationData: [],
    submitSuccess: false,
    submitSuccessMessage: "",
    submitError: null,
};

const reseLeakDetectionMonitoringReducer = (state = initialState, action = { type: "", payload: null }) => {
    switch (action.type) {
        case GET_RESE_LEAK_MONITORING_TABLE_DATA.SUCCESS: {
            const { monitoringDataList, totalRecords } = action.payload;
            return {
                ...state,
                reseLeakMonitoringTableData: monitoringDataList,
                totalRecords
            };
        }

        case GET_RESE_LEAK_MONITORING_TABLE_DATA.ERROR:
            return {
                ...state,
                reseLeakMonitoringTableData: [],
                totalRecords: 0
            };

        case GET_RESE_LEAK_MONITORING_MATERIAL_TYPE.SUCCESS:
            return {
                ...state,
                reseLeakMonitoringMaterialTypeData: action.payload
            };

        case GET_RESE_LEAK_MONITORING_MATERIAL_DURATION.SUCCESS:
            return {
                ...state,
                reseLeakMonitoringMaterialDurationData: action.payload
            };

        case POST_RESE_LEAK_MONITORING_INFORMATION.SUCCESS:
            return {
                ...state,
                submitSuccess: true,
                submitSuccessMessage: action.payload,
                submitError: null
            };

        case POST_RESE_LEAK_MONITORING_INFORMATION.ERROR:
            return {
                ...state,
                submitSuccess: false,
                submitError: action.payload
            };

        case RESET_RESE_LEAK_MONITORING_SUBMIT_STATUS:
            return {
                ...state,
                submitSuccess: false,
                submitSuccessMessage: "",
                submitError: null
            };

        default:
            return state;
    }
};

export default reseLeakDetectionMonitoringReducer;
